import { api } from "..";

export interface UpdateStepUpPasswordPayload {
  currentPassword: string;
  password: string;
}

export interface UpdateStepUpPasswordResponse {
  success: boolean;
}

export async function updateStepUpPassword(
  payload: UpdateStepUpPasswordPayload
): Promise<UpdateStepUpPasswordResponse> {
  const res = await api.client.put("/auth-new/step-up-password", payload);
  return res.data;
}
